import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { UI_LANGUAGES } from "./languages";

// Chargement automatique de toutes les locales présentes dans ./locales
const ctx = require.context("./locales", false, /\.json$/);
const resources = {};
ctx.keys().forEach((key) => {
  const code = key.replace("./", "").replace(".json", "");
  resources[code] = { translation: ctx(key) };
});

export const LANGUAGES = UI_LANGUAGES;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: UI_LANGUAGES.map((l) => l.code),
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "rp_lang",
    },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
